<div class="mt-2 fixed-right  elevate-slider pr-2" [ngClass]="{'large-shelf-slider':isLargeSlider}">
  <div class="left-shelf" >
    <div class="app-slider-close">
      <button class="close  mr-2 pt-3 pr-3" (click)="closeSlider()" type="button">
        <span>
          <i class="fa fa-times"></i>
        </span>
      </button>
    </div>
    <ng-content></ng-content>
    <div class="form-group mb-4 slider-footer-cancel">
      <button class="btn btn-ghost w-100" type="button" (click)="closeSlider()">Cancel</button>
    </div>
  </div>
</div>
